import React, { useState, useEffect } from "react";
import "./Reviews.css";
import { Container } from "react-bootstrap";
import { reviewService } from "../../../components/Review/services/reviewService";
import { Review } from "../../Data/Reviews";
import ReviewManagement from "../../Reusables/ReviewManagement/ReviewManagement";

const Reviews: React.FC = () => {
    const [reviews, setReviews] = useState<Review[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchPendingReviews = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await reviewService.getPendingReviews();
            setReviews(response.data.reviews || []);
        } catch (err) {
            console.error('Error fetching pending reviews:', err);
            setError('Failed to load pending reviews. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPendingReviews();
    }, []);

    const handleReviewsChange = (updatedReviews: Review[]) => {
        setReviews(updatedReviews);
    };

    return (
        <Container fluid className="admin-page-container py-4">
            <ReviewManagement
                reviews={reviews}
                loading={loading}
                error={error}
                title="Pending Reviews Management"
                description="Review and moderate pending user reviews for trails."
                emptyMessage="No pending reviews found. Great job keeping up with moderation!"
                showTrailInfo={true}
                removeOnAccept={true}
                removeOnReject={true}
                onReviewsChange={handleReviewsChange}
            />
        </Container>
    );
};

export default Reviews;